import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2ArrowRightOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" data-name="Artwork" viewBox="0 0 32 32" width="1em" height="1em"><path d="m25 15-1.155 2H2l1.155-2zm-6.337-8.978 8.992 9.98-8.945 9.978 1.489 1.335 10.146-11.317L20.148 4.683z" /></svg>
);
